import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

import { Subscription } from 'rxjs/Rx';

import { TranslateService } from '@ngx-translate/core';

import { RootService } from '../../service/root.service';

import { DashboardService } from './dashboard.service';

@Component({

    selector: 'dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {
    
    
    @Input() id: number;
    @Input() operation: string;
    roles: Object;
    fromRoute: boolean;

    routeEvent: Subscription;
    requestXHR: Subscription;
    requestError: boolean;
    noResult: boolean;


    constructor(public rootService: RootService,
        private dashboardService: DashboardService,
        private route: ActivatedRoute,
        private router: Router,
        private translate: TranslateService) {

        var routeData = this.route.snapshot.data;
        this.fromRoute = routeData['fromRoute'];
        this.operation = routeData['operation'];


    }
    ngOnChanges() {
        
    }
    
    
    ngOnInit() {
        


    }
    ngOnDestroy() {
        if (this.requestXHR) {
            this.requestXHR.unsubscribe();
        }
        if (this.routeEvent) {
            this.routeEvent.unsubscribe();
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/admin/dashboard/dashboard.component.ts